import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/adminpushmade.css";
import AdminPushMadeTemplate from "./modal/AdminPushMadeTemplate";
import AdminMainModal from "./modal/AdminPushTemplateEditModal";
import AdminPushTemplateDeleteCheckModal from "./modal/AdminPushTemplateDeleteCheckModal";
import { apiGet, apiCall } from "../../utils/apiClient";

const AdminPushTemplate = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("direct");
  const [activeTarget, setActiveTarget] = useState("cust");
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [deleteMode, setDeleteMode] = useState(false);
  const [selectedDeleteItems, setSelectedDeleteItems] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [deleteCheckModalOpen, setDeleteCheckModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null)

  const [templateList, setTemplateList] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const ITEMS_PER_PAGE = 20;

  const fetchTemplates = async () => {
    setIsLoading(true);
    try {
      const receiverType = encodeURIComponent(
        activeTarget === "cust" ? "CUST" : "STORE",
      );
      const response = await apiGet(
        `/admin/pushTemplate?page=${currentPage - 1}&size=${ITEMS_PER_PAGE}&isAuto=${activeTab === "auto"}&receiverType=${receiverType}`,
      );
      if (response.ok) {
        const data = await response.json();
        setTemplateList(data.content);
        setTotalElements(data.totalElements);
        setTotalPages(data.totalPages);
      }
    } catch (e) {
      console.error("템플릿 목록 조회 실패:", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, activeTarget, currentPage]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setDeleteMode(false);
    setSelectedDeleteItems([]);
  }, [currentPage]);

  const handleCardClick = (item) => {
    if (deleteMode) {
      setSelectedDeleteItems((prev) =>
        prev.includes(item.pushTemplateIdx)
          ? prev.filter((id) => id !== item.pushTemplateIdx)
          : [...prev, item.pushTemplateIdx],
      );
    } else {
      setSelectedItem(item);
    }
  };

  const handleCancelDelete = () => {
    setDeleteMode(false);
    setSelectedDeleteItems([]);
  };

  const handleConfirmDelete = async () => {
    if (selectedDeleteItems.length === 0) return;
    setIsDeleting(true);
    try {
      const response = await apiCall("/admin/pushTemplate", {
        method: "DELETE",
        body: JSON.stringify({ pushTemplateIdxs: selectedDeleteItems }),
      });
      if (response.ok) {
        setDeleteMode(false);
        setSelectedDeleteItems([]);
        setDeleteCheckModalOpen(false);
        fetchTemplates();
      } else {
        console.error("템플릿 삭제 실패:", response.status);
      }
    } catch (e) {
      console.error("템플릿 삭제 오류:", e);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setActiveTarget("cust");
    setCurrentPage(1);
    setSelectedItem(null);
  };

  const handleTargetChange = (target) => {
    setActiveTarget(target);
    setCurrentPage(1);
    setSelectedItem(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleTemplateSuccess = () => {
    fetchTemplates();
  };

  const handleEditClick = (e, item) => {
    e.stopPropagation();
    setEditItem(item);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setEditItem(null);
  };

  const handleEditSuccess = () => {
    fetchTemplates();
  };

  return (
    <div className="adminpushmade-container">
      <div className="adminpushmade-wrap">
        <div className="adminpushmade-fixed-area">
          {/* 탭 네비게이션 */}
          <div className="adminpushmade-tab-navigation">
            <button
              className={`adminpushmade-tab-btn ${activeTab === "direct" ? "adminpushmade-tab-active" : ""}`}
              onClick={() => handleTabChange("direct")}
            >
              즉시 발송
            </button>
            <button
              className={`adminpushmade-tab-btn ${activeTab === "auto" ? "adminpushmade-tab-active" : ""}`}
              onClick={() => handleTabChange("auto")}
            >
              시스템 발송(자동)
            </button>
            <button
              className="adminpushmade-back-btn"
              onClick={() => navigate("/admin/push")}
            >
              뒤로가기
            </button>
          </div>

          {/* 헤더 영역 */}
          <div className="adminpushmade-header">
            <div className="adminpushmade-btn-section">
              <div className="adminpushmade-btn-group">
                <button
                  className={`adminpushmade-target-btn ${activeTarget === "cust" ? "adminpushmade-target-btn-active" : "adminpushmade-target-btn-inactive"}`}
                  onClick={() => handleTargetChange("cust")}
                >
                  사용자
                </button>
                <button
                  className={`adminpushmade-target-btn ${activeTarget === "store" ? "adminpushmade-target-btn-active" : "adminpushmade-target-btn-inactive"}`}
                  onClick={() => handleTargetChange("store")}
                >
                  가맹점
                </button>
              </div>

              {deleteMode ? (
                <div className="adminpushmade-delete-section">
                  <div className="adminpushmade-delete-count">
                    {selectedDeleteItems.length}개 선택됨
                  </div>
                  <div className="adminpushmade-delete-actions">
                    <button
                      className="adminpushmade-confirm-delete-btn"
                      disabled={selectedDeleteItems.length === 0 || isDeleting}
                      onClick={() => setDeleteCheckModalOpen(true)}
                    >
                      선택 삭제
                    </button>
                    <button
                      className="adminpushmade-deselect-btn"
                      onClick={handleCancelDelete}
                    >
                      취소
                    </button>
                  </div>
                </div>
              ) : (
                <div className="adminpushmade-info-section">
                  <div className="adminpushmade-table-info">
                    총 <b>{totalElements}</b>건
                  </div>

                  <div className="adminpushmade-table-btn-group">
                    <button
                      className="adminpushmade-template-btn"
                      onClick={() => setIsModalOpen(true)}
                    >
                      + 템플릿 등록
                    </button>
                    <button
                      className="adminpushmade-delete-btn"
                      onClick={() => setDeleteMode(true)}
                    >
                      삭제
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="adminpushmade-preview-section">
              <div className="adminpushmade-preview-group">
                <div className="adminpushmade-preview-helptext">
                  <div>수신자 기기에 실제로 표시되는 푸시 미리보기입니다.</div>
                </div>
                <div className="adminpushmade-preview-cards">
                <div className="adminpushmade-preview-card">
                  <div className="adminpushmade-preview-icon">
                    <img
                      src="/images/dnbn_icon.png"
                      alt="icon"
                      className="adminpushmade-preview-icon-img"
                    />
                  </div>
                  <div className="adminpushmade-preview-body">
                    <div className="adminpushmade-preview-title-row">
                      <span className="adminpushmade-preview-title">
                        {selectedItem ? selectedItem.title : "제목"}
                      </span>
                      {activeTab === "auto" ? (
                        <div className="adminpushmade-preview-time">
                          {selectedItem
                            ? selectedItem.sendDateTime?.slice(0, 5)
                            : "방금 전"}
                        </div>
                      ) : (
                        <div className="adminpushmade-preview-time">
                          {new Date().toLocaleTimeString("ko-KR", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}
                        </div>
                      )}
                    </div>
                    <div className="adminpushmade-preview-content">
                      {selectedItem
                        ? selectedItem.content
                        : "카드를 클릭하면 미리보기가 표시됩니다."}
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>

        <div className="adminpushmade-push-grid-container">
          {isLoading ? (
            <div className="adminpushmade-empty">로딩 중...</div>
          ) : templateList.length === 0 ? (
            <div className="adminpushmade-empty">
              등록된 푸시 알림이 없습니다.
            </div>
          ) : (
            (() => {
              const groups = {};
              templateList.forEach((item) => {
                const key = item.sendDateTime ? item.sendDateTime.slice(0, 5) : "";
                if (!groups[key]) groups[key] = [];
                groups[key].push(item);
              });
              const sortedGroups = Object.entries(groups).sort(([a], [b]) => {
                if (a === "" && b === "") return 0;
                if (a === "") return 1;
                if (b === "") return -1;
                return a.localeCompare(b);
              });
              return sortedGroups.map(([timeKey, items]) => (
                <div key={timeKey || "no-time"} className="adminpushmade-time-group">
                  {timeKey && (
                    <div className="adminpushmade-time-group-header">
                      {timeKey}
                    </div>
                  )}
                  <div className="adminpushmade-push-grid">
                    {items.map((item) => (
                      <div
                        className={`adminpushmade-push-card ${
                          deleteMode
                            ? `adminpushmade-push-card-delete-mode ${selectedDeleteItems.includes(item.pushTemplateIdx) ? "adminpushmade-push-card-delete-selected" : ""}`
                            : selectedItem?.pushTemplateIdx === item.pushTemplateIdx
                              ? "adminpushmade-push-card-selected"
                              : ""
                        }`}
                        key={item.pushTemplateIdx}
                        onClick={() => handleCardClick(item)}
                      >
                        <div className="adminpushmade-card-title-row">
                          <span className="adminpushmade-card-title">{item.title}</span>
                          {item.sendDateTime && (
                            <span className="adminpushmade-card-time">
                              {item.sendDateTime.slice(0, 5)}
                            </span>
                          )}
                        </div>
                        <div className="adminpushmade-card-actions">
                          <div className="adminpushmade-card-content">
                            {item.content}
                          </div>
                          <div className="adminpushmade-card-btns">
                            <button
                              className="adminpushmade-edit-btn"
                              onClick={(e) => handleEditClick(e, item)}
                            >
                              수정
                            </button>
                            {/* <button className="adminpushmade-remove-btn">삭제</button> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ));
            })()
          )}
        </div>

        {/* 페이지네이션 */}
        <div className="adminpushmade-pagination">
          <button
            className="adminpushmade-page-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            이전
          </button>
          {Array.from({ length: Math.max(1, totalPages) }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              className={`adminpushmade-page-btn ${currentPage === page ? "active" : ""}`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="adminpushmade-page-btn"
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            다음
          </button>
        </div>
      </div>

      {isModalOpen && (
        <AdminPushMadeTemplate
          onClose={handleCloseModal}
          activeType={activeTab}
          activeTarget={activeTarget}
          onSuccess={handleTemplateSuccess}
        />
      )}

      {isEditModalOpen && (
        <AdminMainModal
          item={editItem}
          activeType={activeTab}
          onClose={handleCloseEditModal}
          onSuccess={handleEditSuccess}
        />
      )}
      {deleteCheckModalOpen && (
        <AdminPushTemplateDeleteCheckModal
          onClose={() => setDeleteCheckModalOpen(false)}
          onConfirm={handleConfirmDelete}
          count={selectedDeleteItems.length}
          isDeleting={isDeleting}
        />
      )}
    </div>
  );
};

export default AdminPushTemplate;
